import { Dispatch } from '~/app/store/types'
import { ENDPOINTS, get } from '~/api'
import { ACCOUNT_ACTIONS } from './const'
import { Account, AccountDetail, ActionTypes, WALLET_TYPES } from './types'
import { keysToCamel } from '~/helpers/helpers'
import { CURRENCY } from '~/types'

export const setAccountList = (accountList: Account[]) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ACCOUNT_ACTIONS.SET_ACCOUNT_LIST,
    accountList,
  })
}

export const setAccountDetailList = (accountDetailList: AccountDetail[]) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: ACCOUNT_ACTIONS.SET_ACCOUNT_DETAIL_LIST,
    accountDetailList,
  })
}

export const fetchAccountList = (onSuccess?: () => void) => async (
  dispatch: Dispatch<ActionTypes>
) => {
  const resp = await get(ENDPOINTS.API_XFERS_ACCOUNTS)

  const accounts = keysToCamel(resp).map((account: Account) => {
    // map dgw's and thb's currency to stablecoin to simplify the logic in FE
    if (
      isSgdDgwAccount(account.currency, account.id) ||
      isSgdTempHoldingBalanceAccount(account.currency, account.id)
    ) {
      return {
        ...account,
        currency: CURRENCY.XSGD,
      }
    }
    return account
  })
  dispatch(setAccountList(accounts as Account[]))

  if (onSuccess) {
    onSuccess()
  }
}

export const fetchAccountDetailList = (onSuccess?: () => void) => async (
  dispatch: Dispatch<ActionTypes>
) => {
  const resp = await get(ENDPOINTS.API_XFERS_ACCOUNTS_INFO_FOR_SDK)

  const accountDetails = keysToCamel(resp.data).map((account: AccountDetail) => {
    // map dgw's and thb's currency to stablecoin to simplify the logic in FE
    if (
      isSgdDgwAccount(account.attributes.currency, account.attributes.walletId) ||
      isSgdTempHoldingBalanceAccount(account.attributes.currency, account.attributes.walletId)
    ) {
      return {
        ...account,
        attributes: {
          ...account.attributes,
          currency: CURRENCY.XSGD,
        },
      }
    }
    return account
  })
  dispatch(setAccountDetailList(accountDetails as AccountDetail[]))

  if (onSuccess) {
    onSuccess()
  }
}

const isSgdDgwAccount = (currency: string, walletId: number) => {
  return currency === CURRENCY.SGD && walletId === WALLET_TYPES.DIGITAL_GOODS
}

const isSgdTempHoldingBalanceAccount = (currency: string, walletId: number) => {
  return currency === CURRENCY.SGD && walletId === WALLET_TYPES.TEMPORARY_HOLDING_BALANCE
}
